import { createSlice } from "@reduxjs/toolkit";
import { get } from "lodash";
import REDUX_SLICE_NAMES from "consts/redux-slice-names";
import { useAppDispatch, useAppSelector } from "../hooks";
import { RootState } from "../store";
import { SearchTextActionType, SearchTextType } from "../reducer-types";

const initialState: SearchTextType = {
  inputValue: "",
  isDisplayHeaderSearch:false,
  refHeader:null
};

export const inputValueSlice = createSlice({
  name: REDUX_SLICE_NAMES.SEARCH_TEXT,
  initialState,
  reducers: {
    setInputValue: (state = initialState, action: SearchTextActionType) => {
      if (action && action.payload) {
        state.inputValue = action.payload.inputValue;
      }
    },
    setDisplayHeaderSearch: (state = initialState, action: SearchTextActionType) => {
      if (action && action.payload) {
        state.isDisplayHeaderSearch = action.payload.isDisplayHeaderSearch;
      }
    },
    setRefHeader: (state = initialState, action: SearchTextActionType) => {
      if (action && action.payload) {
        state.refHeader = action.payload.refHeader;
      }
    },
  },
});

export const { setInputValue,setDisplayHeaderSearch,setRefHeader } = inputValueSlice.actions;

export const useGetInputValue = () =>
  useAppSelector((state: RootState) => state[inputValueSlice.name]);



export const useSetInputValue = () => {
  const dispatch = useAppDispatch();
  return {
    onChangeInputValue: (searchText: string) =>
      dispatch(setInputValue({ inputValue: searchText })),
  };
};

export const useSetDisplayHeaderSearch = ()=>{
  const dispatch = useAppDispatch();
  return {
    onChangeDisplayHeader: (value:boolean)=>{
        dispatch(setDisplayHeaderSearch({isDisplayHeaderSearch:value}))

    },
    onChangeRefHeader:(value:any)=>{
        dispatch(setRefHeader({refHeader:value}))

    }
  }
}


export default inputValueSlice;
